export const routesMusteri = [
  {
    path: "/musteri",
    name: "musteri",
    component: () => import("@/views/musteri_time/index.vue"),
    meta: {
      public: false,
      title: "Müşteri",
      yetki: { k: [1010702] },
    },
  },
]
